import { makeStyles } from '@material-ui/core'
import React from 'react'
import PropTypes from 'prop-types'

const useStyles = makeStyles(theme => ({
    button: {
        backgroundColor: 'transparent',
        cursor: 'pointer',
        width: 54,
        height: 54,
        outline: 'none',
        borderWidth: 1,
        borderColor: '#ACACAC',
        color: '#00000',
        borderRadius: '50%'
    }
}))

/**
 * Rounded icon button for table actions
 */
const OutlineIconButton = ({children, onClick}) => {
    const classes = useStyles()

    return <button className={classes.button} onClick={onClick}>{children}</button>
}

OutlineIconButton.propTypes = {
    onClick: PropTypes.func,
    children: PropTypes.element
}

export default OutlineIconButton
